<template>
  <v-container fluid fill-height>
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm8 elevation-6>
        <v-toolbar class="py-1 blue">
          <v-toolbar-title class="white--text">
            <h4>Life RTL Login</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text class="pt-4">
            <div>
              <v-form v-model="valid" ref="form">
                <v-text-field label="Enter your registered email" v-model="username" :rules="usernameRules" required autofocus></v-text-field>
                <v-text-field v-on:keyup.enter="login" label="Password" v-model="password" min="8" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" :rules="passwordRules" counter @click:append="show1 = !show1"></v-text-field>
                <v-layout justify-space-between>
                  <v-btn v-on:click="login" class="blue darken-4 white--text">Login</v-btn>
                  <span v-if="displayErrorMessageBool" class="red--text">
                    {{ errorMessage }}
                  </span>
                </v-layout>
              </v-form>
            </div>
            <br />
            <div>
              Forgot Your Password?
              <v-btn color="blue lighten-2" v-on:click="$router.push('/forgotpassword')" class="px-1">Reset Password</v-btn>
            </div>
            <br />
            <div>
              Don't have an account?
              <v-btn color="blue lighten-2" v-on:click="$router.push('/register')" class="px-1">Register</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  created: function () {
    this.$store.dispatch("logout");
  },
  data() {
    return {
      valid: false,
      show1: false,
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
      username: "",
      usernameRules: [
        (v) => !!v || "Username is required",
        // (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      displayErrorMessageBool: false,
      errorMessage: "",
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$refs.form.$el.submit();
      }
    },
    login: function () {
      if (this.$refs.form.validate()) {
        let username = this.username;
        let password = this.password;
        this.$store
          .dispatch("login", { username, password })
          .then(() => this.$router.push(this.$route.query.redirect || "/home"))
          .catch(() => {
            this.errorMessage = "Invalid Email or Password";
            this.displayErrorMessageBool = true;
          });
      }
    },
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style>
.loginOverlay {
  background: rgba(33, 150, 243, 0.3);
}
</style>
